<loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
<div class="panel__wrapper w-[58rem] max-w-full h-screen bg-[#F5F5F5] absolute top-0 right-0 flex flex-col gap-3 p-5 shadow-xl">
  <div class="flex justify-between">
    <div class="flex justify-between gap-2">
      <p-button
        severity="success"
        variant="outlined"
        class="p-button-sm"
        icon="pi pi-print"
        [label]="('rollsProgramming.printBarcode' | translateWF: 'Print Barcode') + ' (' + selectedRollIds.size + ')'"
        (onClick)="printSelectedBarcodes()"
        [disabled]="selectedRollIds.size <= 0"
      />
      <p-button
        severity="danger"
        variant="outlined"
        class="p-button-sm"
        icon="pi pi-trash"
        [label]="('rollsProgramming.deleteRolls' | translateWF: 'Delete Rolls') + ' (' + selectedRollIds.size + ')'"
        (onClick)="deleteRollsByBatch()"
        [disabled]="selectedRollIds.size <= 0"
      />
    </div>

    <p-button class="p-button-sm" [label]="'Close' | translate" variant="outlined" (click)="onClose()" />
  </div>
  <header class="line">
    <div>
      <h3 class="m-0">
        {{ 'rolls' | translateWF: 'Rolls' }}
      </h3>
    </div>
  </header>
  <p-table
    [value]="rolls"
    class="block w-full min-w-0 flex-1 min-h-0"
    [scrollable]="true"
    scrollHeight="flex"
    selectionMode="multiple"
    [metaKeySelection]="false"
    [(selection)]="selectedRolls"
    (selectionChange)="onSelectionChange($event)"
    (onSort)="onSort($event)"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    dataKey="number"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>
          <p-checkbox (onChange)="toggleAllSelection($event)" [binary]="true" [ngModel]="isAllSelected()" styleClass="p-checkbox-sm" />
        </th>
        <th pSortableColumn="number">
          {{ 'rollsProgramming.rollNumber' | translateWF: 'Roll Number' }}
          <p-sortIcon field="number"></p-sortIcon>
        </th>
        <th pSortableColumn="assetId">
          {{ 'rollsProgramming.knittingMachine' | translateWF: 'Knitting Machine' }}
          <p-sortIcon field="assetId"></p-sortIcon>
        </th>
        <th pSortableColumn="plannedWeight">
          {{ 'rollsProgramming.expectedWeight' | translateWF: 'Expected Weight' }}
          <p-sortIcon field="plannedWeight"></p-sortIcon>
        </th>
        <th pSortableColumn="lastPrintedDate">
          {{ 'rollsProgramming.lastPrintedDate' | translateWF: 'Last Printed Date' }}
          <p-sortIcon field="lastPrintedDate"></p-sortIcon>
        </th>
        <th pSortableColumn="stationTimeStamps">
          {{ 'rollsProgramming.isProduced' | translateWF: 'isProduced' }}
          <p-sortIcon field="stationTimeStamps"></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-roll let-rowIndex="rowIndex">
      <tr [pSelectableRow]="roll" [pSelectableRowIndex]="rowIndex">
        <td>
          <p-checkbox
            (onChange)="toggleRollSelection(roll.number!, $event)"
            [binary]="true"
            [ngModel]="selectedRollIds.has(roll.number!)"
            [disabled]="roll.status === 2"
            styleClass="p-checkbox-sm"
          />
        </td>
        <td>{{ roll.number }}</td>
        <td>{{ roll.assetId }}</td>
        <td>{{ roll.plannedWeight }}</td>
        <td>{{ roll.lastPrintedDate?.toString() | date }}</td>
        <td>{{ isRollProduced(roll) ? ('Yes' | translateWF: 'Yes') : 'No' }}</td>
        <td>
          <p-button *ngIf="!roll.stationTimeStamps" variant="text" icon="pi pi-trash" severity="danger" (click)="deleteRoll(roll.id!)" />
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
